import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { OrderComponent } from './order/order.component';

const routes: Routes = [
  {path:'home', component:HomeComponent},
  {path: 'contact', component:ContactComponent},
  {path: 'order', component:OrderComponent},
  {path:'**', redirectTo:'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
